var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import { withTheme } from 'styled-components';
import { Bar, HorizontalBar } from 'react-chartjs-2';
import { tooltipConfig } from './chart-integration';
import { get } from '../utils/funcs';
var defaultConfig = {};

var getTooltipLabel = function getTooltipLabel(tooltipItem, data, config) {
  var index = get(tooltipItem, 'datasetIndex', -1);
  var label = get(data, "datasets[" + index + "].label", '');
  var yLabel = config.formatter ? config.formatter(tooltipItem.yLabel) : tooltipItem.yLabel;
  var xLabel = config.titleFormatter ? config.titleFormatter(tooltipItem.xLabel) : tooltipItem.xLabel;
  return config.horizontal ? label + ": " + xLabel : label + ": " + yLabel;
};

var getTooltipTitle = function getTooltipTitle(tooltipItem, config) {
  var xLabel = get(tooltipItem, '[0].xLabel');
  var formattedXLabel = config.titleFormatter ? config.titleFormatter(xLabel) : xLabel;
  var yLabel = get(tooltipItem, '[0].yLabel');
  var formattedYLabel = config.titleFormatter ? config.titleFormatter(yLabel) : yLabel;
  return config.horizontal ? "" + formattedYLabel : "" + formattedXLabel;
};

var barChart = function barChart(_a) {
  var bars = _a.bars,
      _b = _a.config,
      config = _b === void 0 ? defaultConfig : _b,
      theme = _a.theme; // Our default library configuration for bar charts

  var libData = {
    datasets: [],
    labels: config.labels || []
  };
  var libOptions = {
    barPercentage: config.barWidth || 0,
    legend: config.legend || {
      display: false,
      position: 'right'
    },
    tooltips: Object.assign(tooltipConfig(theme), {
      callbacks: __assign(__assign({}, tooltipConfig(theme).callbacks), {
        label: function label(tooltipItem, data) {
          return getTooltipLabel(tooltipItem, data, config);
        },
        title: function title(tooltipItem) {
          return getTooltipTitle(tooltipItem, config);
        }
      })
    }),
    scales: {
      xAxes: [{
        display: true,
        gridLines: false,
        scaleLabel: {
          display: config.showXAxisLabel,
          labelString: config.xAxisLabel,
          fontColor: theme.textPrimary,
          fontSize: config.axisLabelFontSize || 14
        },
        ticks: {
          source: 'labels',
          padding: 16,
          callback: function callback(value) {
            return config.formatter ? config.formatter(value) : value;
          },
          fontColor: theme.textPrimary,
          minor: {
            fontColor: theme.textPrimary,
            fontSize: config.tickFontSize || 12
          }
        }
      }],
      yAxes: [{
        display: true,
        gridLines: false,
        scaleLabel: {
          display: config.showYAxisLabel,
          labelString: config.yAxisLabel,
          fontColor: theme.textPrimary,
          fontSize: config.axisLabelFontSize || 14
        },
        ticks: {
          source: 'labels',
          padding: 16,
          callback: function callback(value) {
            return config.formatter ? config.formatter(value) : value;
          },
          minor: {
            fontColor: theme.textPrimary,
            fontSize: config.tickFontSize || 12
          }
        }
      }]
    }
  };
  bars.forEach(function (series, i) {
    var max = config.max ? config.max : Math.max.apply(Math, series.data);
    var min = config.min ? config.min : Math.min.apply(Math, series.data);
    libOptions.scales.yAxes[0].ticks['suggestedMax'] = config.max ? config.max : max * 1.05;
    libOptions.scales.yAxes[0].ticks['suggestedMin'] = config.min ? config.min : min * 0.95;
    var backgroundColors = [];
    var hoverBackgroundColors = [];

    for (var j = 0; j < series.data.length; j++) {
      var background = series.backgroundColor ? series.backgroundColor[j % series.backgroundColor.length] : null;
      var hoverBackground = null;

      if (series.hoverBackgroundColor) {
        hoverBackground = series.hoverBackgroundColor ? series.hoverBackgroundColor[j % series.hoverBackgroundColor.length] : null;
      } else {
        hoverBackground = background !== null ? theme.colorLevel(background, -2) : null;
      }

      backgroundColors.push(background
      /*&& series.backgroundColor[j]*/
      || theme.modularColor(series.allSameColor ? i : j, 0 + (series.allSameColor ? 0 : i), theme));
      hoverBackgroundColors.push(hoverBackground
      /*&& series.hoverBackgroundColor[j]*/
      || theme.modularColor(series.allSameColor ? i : j, -2 + (series.allSameColor ? 0 : i), theme));
    }

    libData.datasets[i] = {
      backgroundColor: backgroundColors,
      hoverBackgroundColor: hoverBackgroundColors,
      data: series.data,
      label: series.title
    };
  });
  return config.horizontal ? React.createElement(HorizontalBar, {
    data: libData,
    options: libOptions
  }) : React.createElement(Bar, {
    data: libData,
    options: libOptions
  });
};

export var ChartBar = withTheme(barChart);